export default __webpack_public_path__ + "static/media/tickNo.45844ee5.svg";